import { AssessmentButtons } from '../assessment/shared';
import { Icon } from '../icon/icon';
import ErrorScreen from './error';

const MaintenancePage = () => (
  <ErrorScreen
    title="Talkiatry is currently down for maintenance."
    subtitle="We expect to be back soon. Thanks for your patience!"
    icon={
      <Icon
        icon="ScrewdriverWrench"
        styleType="duotone"
        color="primary"
        fontSize="large"
      />
    }
  >
    <AssessmentButtons
      primary={{
        children: 'hello@talkiatry.com',
        type: 'button',
        endIcon: null,
        onClick: null,
        href: 'mailto:hello@talkiatry.com',
      }}
      secondary={{
        children: 'Back to talkiatry.com',
        type: 'button',
        endIcon: null,
        onClick: () => {
          window.location.assign('https://www.talkiatry.com/');
        },
      }}
    />
  </ErrorScreen>
);

export default MaintenancePage;
